import {
  Page,
  Header,
  Content,
  Table,
  TableColumn,
  WarningPanel,
  Link,
  StatusOK,
  StatusWarning,
} from '@backstage/core-components';
import { Chip, Tooltip } from '@material-ui/core';
import {
  Component,
  MaintainerRow,
  useMaintainersMetrics,
} from './useMaintainersMetrics';

const columns: TableColumn<MaintainerRow>[] = [
  {
    title: 'Maintainer',
    field: 'displayName',
    width: '22%',
    render: r => (
      <Link to={`/catalog/${r.namespace}/${r.kind}/${r.name}`}>
        {r.displayName}
      </Link>
    ),
  },
  {
    title: 'Status',
    field: 'accountEnabled',
    width: '10%',
    defaultSort: 'asc',
    customSort: (a, b) => Number(b.accountEnabled) - Number(a.accountEnabled),
    render: r =>
      r.accountEnabled ? (
        <Tooltip title="Microsoft Entra account is active">
          <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <StatusOK />Active
          </span>
        </Tooltip>
      ) : (
        <Tooltip title="Microsoft Entra account is inactive">
          <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <StatusWarning />Inactive
          </span>
        </Tooltip>
      ),
  },
  {
    title: 'Components',
    customFilterAndSearch: (filter: string, rowData: MaintainerRow) =>
      rowData.components.some(c =>
        c.name.toLowerCase().includes(filter.toLowerCase()),
      ) || rowData.displayName.toLowerCase().includes(filter.toLowerCase()),
    customSort: (a, b) => a.components.length - b.components.length,
    render: r => (
      <span style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
        {r.components.map((c: Component) => (
          <Chip
            key={c.ref}
            label={c.name}
            size="small"
            variant="outlined"
            onClick={() => {
              window.location.href = `/catalog/${c.namespace}/${c.kind}/${c.name}`;
            }}
            clickable
          />
        ))}
      </span>
    ),
  },
  {
    title: 'Components Number',
    width: '15%',
    customSort: (a, b) => a.components.length - b.components.length,
    render: r => r.components.length,
  },
];

export function MaintainersDashboardPage() {
  const { data, loading, error } = useMaintainersMetrics();

  return (
    <Page themeId="documentation">
      <Header
        title="Maintainers"
        subtitle="Maintainers declared in each repository definition (bitbucket-<project-key>-management)"
      />
      <Content>
        {error && (
          <WarningPanel
            severity="error"
            title="Loading error"
            message={error.message}
          />
        )}
        <Table
          title={
            loading
              ? 'Loading…'
              : `${data.length} maintainer${data.length > 1 ? 's' : ''}`
          }
          isLoading={loading}
          data={data}
          columns={columns}
          options={{
            pageSize: 25,
            pageSizeOptions: [10, 25, 50],
            search: true,
            sorting: true,
          }}
        />
      </Content>
    </Page>
  );
}